/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_XxsInputs */

const en_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const es_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const fr_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const de_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const ja_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const zh_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const ar_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صغير جداً جداً (XXS)`)
};

const id_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const it_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const ru_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

const pt_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PP (XXS)`)
};

const ko_val_xxs = /** @type {(inputs: Val_XxsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XXS`)
};

/**
* | output |
* | --- |
* | "XXS" |
*
* @param {Val_XxsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_xxs = /** @type {((inputs?: Val_XxsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_XxsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_xxs(inputs)
	if (locale === "es") return es_val_xxs(inputs)
	if (locale === "fr") return fr_val_xxs(inputs)
	if (locale === "de") return de_val_xxs(inputs)
	if (locale === "ja") return ja_val_xxs(inputs)
	if (locale === "zh") return zh_val_xxs(inputs)
	if (locale === "ar") return ar_val_xxs(inputs)
	if (locale === "id") return id_val_xxs(inputs)
	if (locale === "it") return it_val_xxs(inputs)
	if (locale === "ru") return ru_val_xxs(inputs)
	if (locale === "pt") return pt_val_xxs(inputs)
	return ko_val_xxs(inputs)
});